module.exports = __webpack_public_path__ + "static/media/pmg.ac0b7bdc.png";